import axios from 'axios';

import {
  GET_UNITS_LIST_REQUEST,
  GET_UNITS_LIST_SUCCESS,
  GET_UNITS_LIST_FAILURE,
  ADD_UNITS_REQUEST,
  ADD_UNITS_SUCCESS,
  ADD_UNITS_FAILURE,
  UPDATE_UNITS_REQUEST,
  UPDATE_UNITS_SUCCESS,
  UPDATE_UNITS_FAILURE,
  DELETE_UNITS_REQUEST,
  DELETE_UNITS_SUCCESS,
  DELETE_UNITS_FAILURE,
} from '../constants/Units';
import { toast } from 'react-toastify';


export const getUnitsList = () => dispatch => {
  dispatch({type: GET_UNITS_LIST_REQUEST});
  axios.get(`/api/units`)
      .then(res => {
        dispatch({
          type: GET_UNITS_LIST_SUCCESS,
          list: res.data.data,
          page: res.data.current_page,
          total_pages: res.data.total,
        });
      }).catch(function (error) {
        if(error.request.status === 401){
          localStorage.removeItem("user");
          window.location.href = '/login'
        }
        dispatch({type: GET_UNITS_LIST_FAILURE});
    });
};

export const addUnit = (unit) => dispatch => {
  dispatch({type: ADD_UNITS_REQUEST});
  axios.post('/api/units', unit)
      .then(res => {
        toast.success("Единица добавлена!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true
        });
        dispatch({type: ADD_UNITS_SUCCESS, unit: res.data});
      }).catch(function (error) {
        toast.error("Произошла ошибка при добавлении", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true
        });
        if(error.response && error.response.status === 401){
          localStorage.removeItem("user");
          window.location.href = '/login'
        }
        dispatch({type: ADD_UNITS_FAILURE});
    });
};

export const editUnit = (unit) => dispatch => {
  dispatch({type: UPDATE_UNITS_REQUEST});
  axios.put('/api/units/'+unit.id, unit)
      .then(res => {
        toast.success("Единица изменена!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true
        });
        dispatch({type: UPDATE_UNITS_SUCCESS, unit: res.data});
      }).catch(function (error) {
        toast.error("Произошла ошибка при редактировании", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true
        });
        if(error.request.status === 401){
          localStorage.removeItem("user");
          window.location.href = '/login'
        }
        dispatch({type: UPDATE_UNITS_FAILURE});
    });
};

export const deleteUnit = (id) => dispatch => {
  dispatch({ type: DELETE_UNITS_REQUEST });
  axios.delete('/api/units/'+id)
      .then(res => {
        toast.success("Единица удалена!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true
        });
        dispatch({ type: DELETE_UNITS_SUCCESS, id: id });
      }).catch(function (error) {
        toast.error("Произошла ошибка при удалении", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true
        });
        if(error.request.status === 401){
          localStorage.removeItem("user");
          window.location.href = '/login'
        }
        dispatch({ type: DELETE_UNITS_FAILURE });
    });
};